import React from "react"
import "./objetCv.scss"
import { Box, Grid } from "@mui/material"
import RadarChart from "./radarShart"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import { useCvSkill } from "../../../../../hooks/useCvSkill"

interface ObjetCvProps {
	theme: ThemeCvDto | null
}

function ObjetCv({ theme }: ObjetCvProps) {
	const { cvSkill, user, loading, error } = useCvSkill()

	const formatDateFrench = (dateValue: string | Date) => {
		const date = dateValue instanceof Date ? dateValue : new Date(dateValue)
		return new Intl.DateTimeFormat("fr-FR", {
			day: "numeric",
			month: "long",
			year: "numeric",
		}).format(date)
	}

	const styleBloc = {
		borderLeft: `2px solid ${theme?.colorBorder}`,
		borderBottom: `2px solid ${theme?.colorBorder}`,
		padding: "30px",
		display: "inline-block",
		backgroundColor: `${theme?.objetColorBackground}`,
		minHeight: "820px",
		backgroundImage: `url("${theme?.objetImageBackground}")`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		backgroundPositionX: "right",
		backgroundPositionY: "top",
		fontFamily: `"${theme?.fontFamily}", "sans-serif"`,
	}

	const styleTitre: React.CSSProperties = {
		backgroundImage: `url("${theme?.objetImageBackgroundTitle}")`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center",
		color: `${theme?.objetColorTitle}`,
	}

	if (loading) {
		return (
			<Grid size={6} style={styleBloc}>
				<Box sx={{ ml: 5, mr: 5, mt: 12, textAlign: "center" }}>
					<p>Chargement des informations...</p>
				</Box>
			</Grid>
		)
	}

	if (error) {
		return (
			<Grid size={6} style={styleBloc}>
				<Box sx={{ ml: 5, mr: 5, mt: 12, textAlign: "center" }}>
					<p style={{ color: "red" }}>{error}</p>
				</Box>
			</Grid>
		)
	}

	return (
		<Grid size={6} style={styleBloc}>
			<Box
				sx={{
					ml: 5,
					mr: 5,
					mt: 12,
					textAlign: "center",
					fontWeight: "bold",
					fontSize: 20,
				}}
				style={styleTitre}
			>
				{user && (
					<div>
						{user.searchSubject === "INTERNSHIP_SUBJECT" ||
						user.searchSubject === "WORK_STUDY_SUBJECT" ? (
							<>
								Recherche de{" "}
								{user.searchSubject === "INTERNSHIP_SUBJECT"
									? "stage"
									: "alternance"}{" "}
								{user.internshipPeriod}
								<br />
							</>
						) : null}
						{user.internshipStartDate && user.internshipEndDate ? (
							<span>
								du {formatDateFrench(user.internshipStartDate)}{" "}
								au {formatDateFrench(user.internshipEndDate)}
							</span>
						) : null}
					</div>
				)}
			</Box>
			<RadarChart theme={theme} cvSkill={cvSkill} />
		</Grid>
	)
}

export default ObjetCv
